const getAuth = state => state.auth.isAuth;

const authSelectors = {
  getAuth,
};

export default authSelectors;
